/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} BannedInputs */

const th_banned = /** @type {(inputs: BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ถูกระงับ`)
};

const en_banned = /** @type {(inputs: BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`banned`)
};

const ja_banned = /** @type {(inputs: BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用停止`)
};

const zh_banned = /** @type {(inputs: BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已封禁`)
};

const es_banned = /** @type {(inputs: BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bloqueada`)
};

const pt_banned = /** @type {(inputs: BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bloqueada`)
};

const id_banned = /** @type {(inputs: BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`diblokir`)
};

const fr_banned = /** @type {(inputs: BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bloqué`)
};

const tl_banned = /** @type {(inputs: BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`naka-ban`)
};

const vi_banned = /** @type {(inputs: BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bị cấm`)
};

const ko_banned = /** @type {(inputs: BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`차단됨`)
};

const de_banned = /** @type {(inputs: BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gesperrt`)
};

const ru_banned = /** @type {(inputs: BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`заблокирован`)
};

const tr_banned = /** @type {(inputs: BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`engellendi`)
};

const it_banned = /** @type {(inputs: BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bloccato`)
};

const pl_banned = /** @type {(inputs: BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zablokowany`)
};

const uk_banned = /** @type {(inputs: BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`заблокований`)
};

const hi_banned = /** @type {(inputs: BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिबंधित`)
};

const ar_banned = /** @type {(inputs: BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محظور`)
};

const ms_banned = /** @type {(inputs: BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`disekat`)
};

const bn_banned = /** @type {(inputs: BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নিষিদ্ধ`)
};

const zh_tw2_banned = /** @type {(inputs: BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已停權`)
};

const zh_hk2_banned = /** @type {(inputs: BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已停權`)
};

const ur_banned = /** @type {(inputs: BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پابندی شدہ`)
};

const fa_banned = /** @type {(inputs: BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مسدود`)
};

const sw_banned = /** @type {(inputs: BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`amezuiwa`)
};

const nl_banned = /** @type {(inputs: BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`geblokkeerd`)
};

/**
* | output |
* | --- |
* | "banned" |
*
* @param {BannedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const banned = /** @type {((inputs?: BannedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<BannedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_banned(inputs)
	if (locale === "ja") return ja_banned(inputs)
	if (locale === "zh") return zh_banned(inputs)
	if (locale === "es") return es_banned(inputs)
	if (locale === "pt") return pt_banned(inputs)
	if (locale === "id") return id_banned(inputs)
	if (locale === "fr") return fr_banned(inputs)
	if (locale === "tl") return tl_banned(inputs)
	if (locale === "vi") return vi_banned(inputs)
	if (locale === "ko") return ko_banned(inputs)
	if (locale === "de") return de_banned(inputs)
	if (locale === "ru") return ru_banned(inputs)
	if (locale === "tr") return tr_banned(inputs)
	if (locale === "it") return it_banned(inputs)
	if (locale === "pl") return pl_banned(inputs)
	if (locale === "uk") return uk_banned(inputs)
	if (locale === "hi") return hi_banned(inputs)
	if (locale === "ar") return ar_banned(inputs)
	if (locale === "ms") return ms_banned(inputs)
	if (locale === "bn") return bn_banned(inputs)
	if (locale === "zh-TW") return zh_tw2_banned(inputs)
	if (locale === "zh-HK") return zh_hk2_banned(inputs)
	if (locale === "ur") return ur_banned(inputs)
	if (locale === "fa") return fa_banned(inputs)
	if (locale === "sw") return sw_banned(inputs)
	if (locale === "nl") return nl_banned(inputs)
	return en_banned(inputs)
});